import { type FC } from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
}

const sizeMap = {
  sm: 'w-8 h-8',
  md: 'w-12 h-12',
  lg: 'w-16 h-16'
};

const LoadingSpinner: FC<LoadingSpinnerProps> = ({ 
  size = 'md',
  color = '#FF3366'
}) => {
  const dimensions = sizeMap[size];

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm z-50">
      <div className="relative">
        <div 
          className={`${dimensions} border-4 rounded-full animate-ping opacity-20`}
          style={{ borderColor: color }}
        />
        <div 
          className={`absolute top-0 ${dimensions} border-4 rounded-full animate-spin`}
          style={{ borderTopColor: color, borderRightColor: 'transparent', borderBottomColor: 'transparent', borderLeftColor: 'transparent' }}
        />
      </div>
    </div>
  );
};

export default LoadingSpinner;